module.exports = __webpack_public_path__ + "img/ИФ-1(А)-031-m.c0e9127c.png";